import type {AxiosRequestConfig} from 'axios';

/**
 * Base axios config shared by all eag-grid API calls.
 * Defined once to avoid creating identical objects in every factory function.
 */
export const AXIOS_BASE_CONFIG: AxiosRequestConfig = {
  headers: {credentials: 'include'},
};

/**
 * Axios config with preset instance param appended.
 * Used by endpoints that need the `instance` query param.
 */
export function makeInstanceConfig(
  presetInstanceId: string | null | undefined
): AxiosRequestConfig {
  return makeParamsConfig({instance: presetInstanceId ?? null});
}

/**
 * Axios config with arbitrary query params appended.
 * The explicit AxiosRequestConfig return type keeps axios from inferring
 * its params generic from the literal, which rejects the shared paramsSerializer.
 */
export function makeParamsConfig(params: Record<string, unknown>): AxiosRequestConfig {
  return {
    ...AXIOS_BASE_CONFIG,
    params,
  };
}
